module.exports = __webpack_public_path__ + "static/media/register.d3937788.PNG";